import { inrAmount } from '../../../../../../utils/formatters/inrAmount';
import { MSME_EMPTY_CELL } from './constants';

export const formatMsmeAmount = (value: number | null): string => (value === null ? MSME_EMPTY_CELL : `₹${formatMsmeDrawerAmount(value)}`);

/** The drawer's amounts carry no ₹. */
export const formatMsmeDrawerAmount = (value: number | null): string => (value === null ? MSME_EMPTY_CELL : inrAmount(Math.round(value)));
